// interface CountryCount {
//   fromcountry: number;
//   tocountry: number;
//   count: number;
// }

// interface ChannelCounts {
//   whatsapp_count: CountryCount[];
//   sms_count: CountryCount[];
// }

// /**
//  * Transforms WhatsApp and SMS UI data into backend payload format.
//  * @param whatsappData Array of selected WhatsApp countries and counts
//  * @param smsData Array of selected SMS countries and counts
//  * @param toCountry Selected destination country (string key)
//  * @param countryCodeMap Mapping of country string keys to numeric codes
//  */

// debugger;
// export function getChannelCounts(
//   whatsappData: { country: string; count: string }[],
//   smsData: { country: string; count: string }[],
//   toCountry: string | null,
//   countryCodeMap: Record<string, number>
// ): ChannelCounts {
//   const toCountryCode = toCountry ? countryCodeMap[toCountry] : null;

//   const mapData = (
//     data: { country: string; count: string }[]
//   ): CountryCount[] => {
//     return data
//       .filter(item => !!item.count && !isNaN(Number(item.count)))
//       .map(item => ({
//         fromcountry: countryCodeMap[item.country],
//         tocountry: toCountryCode || 0,
//         count: Number(item.count),
//       }));
//   };

//   return {
//     whatsapp_count: mapData(whatsappData),
//     sms_count: mapData(smsData),
//   };
// }

interface CountryCount {
  fromcountry: string; // ISO like 'IN'
  tocountry: string;   // ISO like 'US'
  count: number;
}

interface ChannelCounts {
  whatsapp_count: CountryCount[];
  sms_count: CountryCount[];
}

/**
 * Transforms WhatsApp and SMS UI data into backend payload format.
 * @param whatsappData Array of selected WhatsApp countries (by name) and counts
 * @param smsData Array of selected SMS countries (by name) and counts
 * @param selectedToCountryISO Destination country ISO code
 * @param fromCountryISOs Mapping from country name to ISO code
 */
export function getChannelCounts(
  whatsappData: { country: string; count: string }[],
  smsData: { country: string; count: string }[],
  selectedToCountryISO: string | null,
  fromCountryISOs: Record<string, string>
): ChannelCounts {
  const toCountryCode = selectedToCountryISO || "";

  const mapData = (
    data: { country: string; count: string }[]
  ): CountryCount[] => {
    return data
      .filter((item) => !!item.count && !isNaN(Number(item.count)))
      .map((item) => ({
        fromcountry: fromCountryISOs[item.country] || "", // convert name to ISO
        tocountry: toCountryCode,
        count: Number(item.count),
      }));
  };

  return {
    whatsapp_count: mapData(whatsappData),
    sms_count: mapData(smsData),
  };
}
